/**
 * 该配置文件打包编译之后内容无法修改， 打包之后需要修改的配置统一放置在static/config/app-config.js
 */

const Local = window.location
// const host = `${Local.protocol}//${ Local.port == '3000' ? Local.hostname +':8080' : Local.host }`;
const host = APPCONFIG.IP
const tdthost = APPCONFIG.tdthost
const geohost = APPCONFIG.DisIp

const Sites = {
  Geoesbmengine: host + '/geoesbmengine',
  GWebframe: host + '/appwebframe',
  Webframe: host + '/webframe',
  Map: host + '/map',
  serpool: host + '/serpool',
  Appframework: tdthost + '/appframework',
  Mapedit: tdthost + '/mapedit',
  // Sysmanager: tdthost +"/sysmanage"
  Sysmanager: tdthost + '/tdtsys'
}
module.exports = {
  ServiceConfig: {
    httpproxy: Sites.GWebframe + '/biz/httpproxy/httpproxy.jsp'
  },
  SgsConfig: {
    GetServiceNodes: Sites.Geoesbmengine + '/services/catalog/resource/service',
    GetCatalogNodes:
      Sites.Geoesbmengine + '/services/catalog/gategoty/view.json',
    GetResourceNodes:
      Sites.Geoesbmengine + '/services/catalog/resource/view.json',
    SearchResource: Sites.Geoesbmengine + '/services/resource/data/full/pri',
    SearchFullResource: Sites.Geoesbmengine + '/services/resource/data/full',
    GetRootTheme:
      Sites.Geoesbmengine + '/services/servicemanager/datacatalog/root.json',
    GetChildTheme:
      Sites.Geoesbmengine + '/services/servicemanager/datacatalog/tree',
    GetServiceDate: Sites.Geoesbmengine + '/services/resource/data/serinfo',
    GetCatalogFormt:
      Sites.Geoesbmengine + '/services/servicemanager/catalogformt/all.json',
    getDatasetsByDataSourceId:
      Sites.serpool + '/services/tree/datasetinfo.json',
    getDatasetInfoByDatasetName: Sites.serpool + '/services/tree',
    GetSerPoolEntityTreeRoot: Sites.serpool + '/services/tree/root.json',
    getSerPoolChildTheme:
      Sites.serpool + '/services/tree/child/datasource.json',
    getEntityServiceList: Sites.serpool + '/services/service/servicelist.json',
    getAllFields: Sites.Geoesbmengine + '/services/datameta/getAllfields', // 获取属性服务所有字段
    fiddlerBehavior:
      Sites.Geoesbmengine + '/services/log/behaviorStat/fiddlerBehavior.json' // 行为监控
  },
  TDTConfig: {
    StyleLayer: Sites.Mapedit + '/services/stylelayer', // 地图定制增加/更新接口
    getStyleLayer: Sites.Mapedit + '/services/stylelayer/getByServiceId', // 查询风格图层
    StyleMap: Sites.Mapedit + '/services/stylemap',
    StyleMapProxy: Sites.Webframe + '/biz/httpproxy/httpproxynew.jsp?url=http://127.0.0.1:8765/stylemap',
    queryMap: Sites.Appframework + '/services/map/manager/query.json',
    addMarkerRecords:
      Sites.Sysmanager + '/services/userMarker/addMarkersAndLayer',
    // getMarkerRecords: Sites.Sysmanager+"/services/userMarker/getMarkerRecords",
    getMarkerRecords:
      Sites.Sysmanager + '/services/userMarker/getMarkerRecordsByPagesize',
    // uploadExcelData: Sites.Mapedit + "/services/mapedit/uploadExcelData",
    uploadExcelData: Sites.Webframe + '/biz/httpproxy/httpproxynew.jsp?url=http://127.0.0.1:8765/mapedit/uploadExcelData',
    queryFieldExcel: Sites.Mapedit + '/services/mapedit/queryFieldExcel',
    downloadTemplate: Sites.Mapedit + '/services/mapedit/downloadTemplate',
    uploadByTypeAndField: Sites.Mapedit + '/services/mapedit/upload',
    queryDatasetByUser: Sites.Mapedit + '/services/mapedit/queryDatasetByUser',
    // queryDatasetByUser: Sites.Webframe + '/biz/httpproxy/httpproxynew.jsp?url=http://127.0.0.1:8080/mapedit/services/mapedit/queryDatasetByUser',
    queryDatasetByUserId: Sites.Webframe + '/biz/httpproxy/httpproxynew.jsp?url=http://127.0.0.1:8765/mapedit/queryDatasetByUserid',
    queryDatasetByPkid: Sites.Mapedit + '/services/mapedit/queryDatasetByPkid',
    // delExcelData: Sites.Mapedit + '/services/mapedit/delExcelData',
    delExcelData: Sites.Webframe + '/biz/httpproxy/httpproxynew.jsp?url=http://127.0.0.1:8765/mapedit/delExcelData',
    // 专题目录管理url
    catalogSpecial: Sites.Appframework + '/services/catalog/catalogSpecial',
    catalogSpecials: Sites.Appframework + '/services/catalog/catalogSpecials',
    // 模块信息
    queryWebModules: Sites.Appframework + '/services/module/getWebModules'
  },
  Geoesbmengine: {
    location: host + '/geoesbmengine'
  },
  Map: {
    location: host + '/map'
  },
  DFC: {
    location: host + '/dfc',
    transformUrl:
      host + '/dfc/services/prjCoordSysTransform/transformpoints/inverse.json',
    GetDataByDatasetid: host + '/dfc/services/sgssfs/'
  },
  GeoEntity: {
    location: geohost + '/geoentity'
  },
  Usercenter: {
    location: host + '/usercenter'
  },
  MapEdit: {
    location: host + '/mapedit'
  },
  Cas: {
    location: host + '/cas'
  },
  Nav: {
    location: host + '/nav'
  },
  Editmanager: {
    location: host + '/editmanager'
  },
  Webframe: {
    location: Sites.GWebframe
  },
  Quota: {
    location: APPCONFIG.QuotaHost + '/quotamanager'
  },
  Serpool: {
    location: host + '/serpool'
  },
  Mule: {
    location: APPCONFIG.MuleHost + '/geoesb/proxy/'
  },
  Condition: {
    greater: '大于',
    greater_eq: '大于等于',
    less: '小于',
    less_eq: '小于等于',
    eq: '等于',
    like: '模糊',
    equals: '等于',
    include: '包含',
    notinclude: '不包含'
  }
}



// WEBPACK FOOTER //
// ./src/config/app-config.js